module.exports = __webpack_public_path__ + "static/media/job_add_info.528cde5b.svg";